//#region imports
import useMediaQuery from '@mui/material/useMediaQuery';
import { Theme } from '@mui/material';

//#endregion

const useMobile = () => {

  const isMobile = !useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));

  return { isMobile };
};

export default useMobile;
